import React from "react";

const Footer = () => {
  return (
    <footer className="px-4 py-16 text-gray-400 bg-black">
      <div className="max-w-[1200px] mx-auto">
        {/* Top Footer */}
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          {/* Product */}
          <div>
            <h3 className="mb-4 font-semibold text-white">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>Token Approval Checker</li>
              <li>Browser Extension</li>
              <li>Exploit Checker</li>
              <li>Permit Signature Checker</li>
              <li>Marketplace Bulk Delister</li>
            </ul>
          </div>

          {/* Learn */}
          <div>
            <h3 className="mb-4 font-semibold text-white">Learn</h3>
            <ul className="space-y-2 text-sm">
              <li>Knowledgebase</li>
              <li>What Are Token Approvals?</li>
              <li>What to Do When Scammed?</li>
              <li>FAQ</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="mb-4 font-semibold text-white">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>Blog</li>
              <li>About Us</li>
              <li>Brand Assets</li>
              <li>Merchandise</li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="mb-4 font-semibold text-white">Community</h3>
            <ul className="space-y-2 text-sm">
              <li>Twitter</li>
              <li>Discord</li>
              <li>GitHub</li>
              <li>Donate</li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 mt-12 text-sm border-t border-gray-800">
          <div className="flex flex-col items-center gap-4 md:flex-row md:items-center md:justify-between">
            {/* Left */}
            <div className="items-center gap-3">
              <p className="text-lg text-center text-white">
                © 2026 Revoke.cash
              </p>
              <div className="space-x-1 text-xs">
                <span>Acknowledgements</span>
                <span>•</span>
                <span>Privacy Policy</span>
                <span>•</span>
                <span>Terms</span>
              </div>
            </div>

            {/* Right */}
            <div className="flex flex-wrap items-center gap-4 text-xs">
              <span>Donations: 0xfcBf17...15F863</span>
              <span>English</span>
              <span>System</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
